"use client";
import React from "react";
import Image from "next/image";
import Link from "next/link";
import {
  Box,
  HStack,
  Heading,
  Icon,
  SimpleGrid,
  Stack,
  Text,
  VStack,
  AspectRatio,
} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {HEADING_VARIANTS} from "@/theme/components/heading";
import {TEXT_VARIANTS} from "@/theme/components/text";
import WorldMap from "public/contactForm/contact-us.jpeg";
import {CONTACT_FORM_CONSTANTS, CONTACT_LIST} from "./contactForm.constants";
import HubspotContactForm from "./components/hubspot";

type Props = {
  showContactInfoOnMobile?: boolean;
};

const ContactForm = (props: Props) => {
  const {showContactInfoOnMobile = true} = props;
  return (
    <Box my={"2rem"} id="contact-us">
      <VStack gap={"1.5rem"}>
        <Heading variant={useSectionHeadingVariant()}> Contact Us</Heading>
        <Text variant={TEXT_VARIANTS.BODY2} color="text.100" textAlign={"center"}>
          <Balancer>Innovative Tech Solutions and Expert Opinions</Balancer>
        </Text>
      </VStack>
      <SimpleGrid
        columns={{base: 1, md: 2, lg: 2}}
        spacing={{base: 6, md: 6}}
        px={{base: 0, md: 4}}
      >
        <VStack>
          <Box padding={{base: "0", sm: "2rem"}}>
            <AspectRatio
              position={"relative"}
              ratio={1}
              width={{base: "full", sm: "350px", md: "280px"}}
            >
              <Image
                alt="Cloud-Application"
                fill
                src={WorldMap}
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </AspectRatio>
          </Box>
          <Box
            display={showContactInfoOnMobile ? "flex" : {base: "none", md: "flex"}}
            flexDirection={{base: "column", md: "row"}}
            gap={"20px"}
          >
            <Stack borderRadius={"8px"} boxShadow={"lg"} p={"20px"} flex="1">
              <Heading
                color={"primary.200"}
                textAlign={"center"}
                mb={2}
                variant={HEADING_VARIANTS.SUBTITLE1}
              >
                {CONTACT_FORM_CONSTANTS.UNITED_STATES}
              </Heading>
              {CONTACT_LIST.map((contact, index) => {
                return (
                  <HStack key={index}>
                    <Icon as={contact.icon} color={"primary.200"} fontSize={"20px"} />
                    <Text
                      as={Link}
                      href={contact.path}
                      target={contact.isExternal ? "_blank" : ""}
                      variant={TEXT_VARIANTS.BODY1}
                      color="text.100"
                      _hover={{color: "primary.200", textDecor: "underline"}}
                    >
                      {contact.label}
                    </Text>
                  </HStack>
                );
              })}
            </Stack>
          </Box>
        </VStack>
        <Box alignSelf={"center"} width={"100%"}>
          <HubspotContactForm />
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default ContactForm;
